(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  };
})();

var Theme = Theme || {};

Theme.Cart = {
  element: null,
  init: function () {
    this.element = document.querySelector("#cart");
    this.addItemListeners();
    this.update();
  },
  add: function (variant, quantity) {
    return new Promise((resolve, reject) => {
      ShopifyAPI.Cart.add(variant, quantity)
        .then((response) => {
          this.update().then(() => {
            resolve(response);
          });
        })
        .catch((error) => {
          if (error == 422) {
            reject();
          }
        });
    });
  },
  update: function () {
    this.element = document.querySelector("#cart");
    return new Promise((resolve, reject) => {
      if (window.location.pathname == "/cart") {
        fetch("/?sections=cart-template", {
          method: "GET",
        })
          .then((response) => response.json())
          .then((data) => {
            let newCart = document.createElement("html");
            newCart.innerHTML = `<body>${data["cart-template"]}</body>`;
            newCart = newCart.querySelector("#shopify-section-cart-template");
            const cartTemplate = document.querySelector("#cart-template > div");
            cartTemplate.innerHTML = newCart.innerHTML;
            this.addItemListeners();
            document.querySelector("#cart-template").dataset.loading = "false";
          });
      }
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const cartFill = document.querySelector("#cart-fill");
          const totalItems = cart.items.reduce(
            (total, item) => total + item.quantity,
            0,
          );
          const maxItems = 3;
          const fillPercentage = Math.min(totalItems / maxItems, 1) * 100;
          cartFill.style.clipPath = `polygon(0% ${100 - fillPercentage}%,100% ${100 - fillPercentage}%,100% 100%,0% 100%)`;
          resolve();
        })
        .catch((error) => {
          console.error("Error fetching cart data:", error);
          reject();
        });
    });
  },
  addItemListeners: function () {
    document
      .querySelectorAll("[data-item-id]")
      .forEach((cartItem, index, array) => {
        // Add delete cart item event listener
        cartItem
          .querySelector("[data-cart-delete]")
          .addEventListener("click", function (event) {
            event.preventDefault();
            document.querySelector("#cart-template").dataset.loading = "true";

            ShopifyAPI.Cart.update(parseInt(cartItem.dataset.itemId), 0).then(
              (response) => {
                Theme.Cart.update().then(() => {});
              },
            );
          });

        // Quantity Increase Listener
        cartItem
          .querySelector("[data-cart-increase]")
          .addEventListener("click", function (event) {
            event.preventDefault();
            document.querySelector("#cart-template").dataset.loading = "true";

            let quantityInputValue =
              this.parentElement.querySelector("input").value;

            ShopifyAPI.Cart.update(
              parseInt(cartItem.dataset.itemId),
              parseInt(quantityInputValue) + 1,
            ).then((response) => {
              Theme.Cart.update().then(() => {});
            });
          });

        // Quantity Decrease Listener
        cartItem
          .querySelector("[data-cart-decrease]")
          .addEventListener("click", function (event) {
            event.preventDefault();

            let quantityInputValue =
              this.parentElement.querySelector("input").value;
            if (parseInt(quantityInputValue) <= 1) {
              return;
            }

            document.querySelector("#cart-template").dataset.loading = "true";

            ShopifyAPI.Cart.update(
              parseInt(cartItem.dataset.itemId),
              parseInt(quantityInputValue) - 1,
            ).then((response) => {
              Theme.Cart.update().then(() => {});
            });
          });
      });
  },
};

Handler = {
  process: function (path, direction) {
    if (path == undefined) return;

    // Enter
    if (direction == 0) {
      window.scrollTo(0, 0);

      if (path == "/") {
        Handler.Enter.index();
      } else if (path.includes("/products/")) {
        Handler.Enter.product();
      } else if (path.includes("/cart")) {
        Handler.Enter.cart();
      } else if (path.startsWith("/collections/")) {
        Handler.Enter.collection();
      } else if (path === "/") {
        Handler.Enter.index();
        if (document.querySelectorAll(".collection").length > 0) {
          Handler.Enter.collection();
        }
      }
    } else if (direction == 1) {
      // Leave
      if (path.includes("/products/")) {
        Handler.Leave.product();
      } else if (path.includes("/cart")) {
        Handler.Leave.cart();
      }
    }
  },
  Enter: {
    index: function () {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      const video = document.querySelector("[data-desktop]");
      const videoLoop = document.querySelector("[data-desktop-loop]");
      const mobileVideo = document.querySelector("[data-mobile]");
      const mobileVideoLoop = document.querySelector("[data-mobile-loop]");

      video.addEventListener("ended", () => {
        video.style.opacity = 0;
        videoLoop.style.opacity = 1;
      });

      mobileVideo.addEventListener("ended", () => {
        mobileVideo.style.opacity = 0;
        mobileVideoLoop.style.opacity = 1;
      });
    },
    collection: function () {
      document.querySelectorAll("[data-product-id]").forEach((productItem) => {
        productItem.addEventListener("click", (event) => {
          document
            .querySelectorAll("[data-product-id]")
            .forEach((otherProductItem) => {
              if (productItem != otherProductItem) {
                otherProductItem.dataset.overlayOpen = "false";
              }
            });

          const state = productItem.dataset.overlayOpen == "true";

          if (event.target.tagName == "A") {
            return;
          }
          productItem.dataset.overlayOpen = state ? "false" : "true";
        });
      });
    },
    product: function () {
      const product = JSON.parse(
        document.getElementById("product-data").innerHTML,
      );
      const productContainer = document.querySelector("#product");
      const addToCartButton =
        productContainer.querySelector("#product-addToCart");
      const priceElements = document.querySelectorAll("#product-price");

      const description = document.querySelector("[data-description]");
      const originalContent = description.innerHTML;
      description.style.height = description.offsetHeight + "px";
      description.innerHTML = "";

      const typeText = (parent, text) => {
        return new Promise((resolve) => {
          let charIndex = 0;
          const textNode = document.createTextNode("");
          parent.appendChild(textNode);

          const typeChar = () => {
            if (charIndex < text.length) {
              textNode.textContent += text.charAt(charIndex);
              charIndex++;
              setTimeout(typeChar, Math.floor(Math.random() * 10) + 30);
            } else {
              resolve();
            }
          };

          typeChar();
        });
      };

      const typeDescription = async (parent, nodes) => {
        for (const node of nodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            await typeText(parent, node.textContent);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const newElement = document.createElement(node.tagName);

            [...node.attributes].forEach((attr) =>
              newElement.setAttribute(attr.name, attr.value),
            );
            parent.appendChild(newElement);

            await typeDescription(newElement, [...node.childNodes]);
          }
        }
      };

      const parsedNodes = [
        ...new DOMParser().parseFromString(originalContent, "text/html").body
          .childNodes,
      ];

      setTimeout(() => {
        typeDescription(description, parsedNodes).then(() => {
          description.style.height = "auto";
        });
      }, 500);

      const swiper = new Swiper(".swiper", {
        slidesPerView: 1,
        preloadImages: true,
        direction: "horizontal",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
      });

      window.addEventListener("resize", () => {
        swiper.updateSize();
        swiper.updateAutoHeight(0);
        swiper.updateSlides();
      });

      document.querySelectorAll("[data-product-variant]").forEach((variant) => {
        const variantData = product.variants.find(
          (v) => v.title == variant.dataset.value,
        );
        if (!variantData.available) {
          variant.dataset.disabled = true;
        } else {
          variant.dataset.disabled = false;
        }
      });

      const updateAddButton = function () {
        if (!product.available) {
          addToCartButton.setAttribute("data-disabled", "true");
          addToCartButton.setAttribute("data-soldout", "true");
          addToCartButton.querySelector(".product-addToCart-text").textContent =
            Theme.l18n.sold_out;
          return;
        }

        let missing = false;
        document.querySelectorAll("[data-product-option]").forEach((option) => {
          if (
            option.querySelector(
              "[data-product-variant][data-variant-selected]",
            )
          ) {
            return;
          }

          if (missing) return;
          if (!option.querySelector("[data-variant-selected]")) {
            addToCartButton.setAttribute("data-disabled", "true");
            addToCartButton.querySelector(
              ".product-addToCart-text",
            ).textContent = `Select a ${option.dataset.optionName}`;
            missing = true;
          }
        });
      };

      let currentVariant = null;
      const selectCallback = function (variant, selector) {
        if (variant) {
          currentVariant = variant;

          if (variant.available) {
            // In stock
            addToCartButton.setAttribute("data-disabled", "false");
            addToCartButton.setAttribute("data-soldout", "false");
            addToCartButton.querySelector(
              ".product-addToCart-text",
            ).textContent = Theme.l18n.add_to_cart;
          } else {
            // Sold out
            addToCartButton.setAttribute("data-disabled", "true");
            addToCartButton.setAttribute("data-soldout", "true");
            addToCartButton.querySelector(
              ".product-addToCart-text",
            ).textContent = Theme.l18n.sold_out;
          }

          priceElements.forEach(
            (priceElement) => (priceElement.innerHTML = ""),
          );
          if (variant.compare_at_price > variant.price) {
            // Sale
            let saleElement = document.createElement("span");
            saleElement.classList.add("product-price--sale");
            saleElement.innerHTML = Shopify.formatMoney(variant.price) + " ";

            let compareElement = document.createElement("span");
            compareElement.classList.add("product-price--compare");
            compareElement.innerHTML = Shopify.formatMoney(
              variant.compare_at_price,
            );

            priceElements.forEach((priceElement) =>
              priceElement.appendChild(saleElement),
            );
            priceElements.forEach((priceElement) =>
              priceElement.appendChild(compareElement),
            );
          } else {
            // Regular price
            priceElements.forEach(
              (priceElement) =>
                (priceElement.innerHTML = Shopify.formatMoney(variant.price)),
            );
          }
        } else {
          addToCartButton.setAttribute("data-disabled", "true");
          addToCartButton.setAttribute("data-soldout", "true");
          addToCartButton.querySelector(".product-addToCart-text").textContent =
            Theme.l18n.variant_unavailable;
        }
      };

      const optionSelector = new Shopify.OptionSelectors(
        "product-variant-selector",
        {
          product: product,
          onVariantSelected: selectCallback,
        },
      );

      productContainer
        .querySelectorAll("[data-product-variant]")
        .forEach((optionElement) => {
          optionElement.addEventListener("click", function () {
            if (this.getAttribute("disabled") === "true") return;
            // e.g. Size, Color
            const optionCategory = optionElement.parentElement.dataset.option;
            // e.g. M, Red
            const optionValue = this.dataset.value;

            productContainer.querySelector(
              `#product-variant-selector-option-${optionCategory}`,
            ).value = optionValue;
            productContainer
              .querySelector(
                `#product-variant-selector-option-${optionCategory}`,
              )
              .dispatchEvent(new Event("change"));

            productContainer
              .querySelectorAll("[data-product-variant][data-variant-selected]")
              .forEach(function (sameOptionElement) {
                if (
                  sameOptionElement.parentElement.dataset.option ===
                  optionCategory
                ) {
                  sameOptionElement.removeAttribute("data-variant-selected");
                }
              });

            this.setAttribute("data-variant-selected", "");
            updateAddButton();
          });
        });

      productContainer
        .querySelector(".shopify-product-form")
        .addEventListener("submit", function (event) {
          event.preventDefault();
          if (!product.available) return;
          if (addToCartButton.getAttribute("data-disabled") == "true") {
            // check if #product-variants exists, then check if user scrolled to it and if not, scroll to it
            if (document.querySelector("#product-variants")) {
              document.querySelector("#product-variants").scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }
            return;
          }

          let animationInterval;
          let animationStep = 0;
          const animationFrames = [".", "..", "..."];

          function startAnimation() {
            animationInterval = setInterval(() => {
              addToCartButton.querySelector(
                ".product-addToCart-text",
              ).textContent = animationFrames[animationStep];
              animationStep = (animationStep + 1) % animationFrames.length;
            }, 200); // Adjust the interval time as needed
          }

          function stopAnimation() {
            clearInterval(animationInterval);
            addToCartButton.querySelector(
              ".product-addToCart-text",
            ).textContent = "Added to Bag";
          }

          startAnimation();

          Theme.Cart.add(currentVariant.id, 1)
            .then((data) => {
              stopAnimation();
              setTimeout(() => {
                addToCartButton.querySelector(
                  ".product-addToCart-text",
                ).textContent = "Add to Bag";
              }, 2000);
            })
            .catch(() => {
              clearInterval(animationInterval);
              alert("All available stock of this item is in your bag.");
            });
        });

      if (
        product.variants.length == 1 &&
        product.variants[0].option1 == "Default Title"
      ) {
        currentVariant = product.variants[0];
        selectCallback(currentVariant, null);
      }

      if (product.available && product.variants.length == 1) {
        document.querySelector("[data-product-variant]").click();
      }

      updateAddButton();
    },
    cart: function () {
      Theme.Cart.update();
    },
  },
  Leave: {
    product: function () {
      //console.log('destroy swiper');
      //Theme.Temporary.productSwiper.destroy();
    },
    cart: function () {},
  },
};

Theme.Transition = {
  init: function () {
    barba.init({
      debug: true,
      prefetchIgnore: "/cart/",
      transitions: [
        {
          leave(data) {
            Theme.Transition.fadeOut(data);
            return new Promise((resolve) => setTimeout(() => resolve(), 350));
          },
          enter(data) {
            setTimeout(() => Theme.Transition.fadeIn(data), 350);
          },
        },
      ],
    });

    barba.hooks.before((data) => {
      setTimeout(() => {
        Handler.process(data.current.url.path, 1);
      }, 500);
    });

    barba.hooks.after((data) => {
      setTimeout(() => {
        Handler.process(data.next.url.path, 0);
      }, 500);
    });

    if (window.location.pathname != "/") {
      this.fadeIn();
    }
    Handler.process(window.location.pathname, 0);
  },
  fadeOut: function (data) {
    const background = document.querySelector("[data-transition-background]");
    const logo = document.querySelector("[data-transition-logo]");

    anime({
      targets: background,
      opacity: 1,
      duration: 350,
      easing: "easeInOutExpo",
    });

    anime({
      targets: logo,
      opacity: 1,
      duration: 350,
      easing: "easeInOutExpo",
    });
  },
  fadeIn: function (data) {
    const background = document.querySelector("[data-transition-background]");
    const logo = document.querySelector("[data-transition-logo]");
    const footerLinks = document.querySelectorAll(
      "footer a, footer span, footer > div > div",
    );

    anime({
      targets: footerLinks,
      opacity: 0,
      duration: 100,
      easing: "easeInOutExpo",
    }).finished.then(() => {
      anime({
        targets: footerLinks,
        opacity: 1,
        duration: 1000,
        delay: anime.stagger(100, { start: 400 }),
        easing: "easeInOutExpo",
      });
    });

    background.style.opacity = 1;
    logo.style.opacity = 1;

    anime({
      targets: background,
      keyframes: [
        {
          opacity: 0,
          duration: 300,
          delay: 600,
        },
      ],
      easing: "easeInOutExpo",
    });

    const headerLogoBox = document
      .querySelector("#header-logo")
      .getBoundingClientRect();

    anime({
      targets: logo,
      keyframes: [
        {
          top: headerLogoBox.top + headerLogoBox.height / 2 + "px",
          duration: 400,
        },
        {
          opacity: 0,
          duration: 100,
          delay: 500,
        },
      ],
      easing: "easeInOutExpo",
    });
  },
};

Theme.Transition.init();
Theme.Cart.init();
